<template>
  <o-form-wrapper
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
    v-model="item"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="name"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="name"
        v-bind="schema.fields.name"
        v-model="item.name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="client"
    >
      <o-select
        :form-state="formState"
        :items="optionOcomClientItems"
        :loading="optionOcomClientWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="client"
        sort-field="name"
        store-name="OcomClient"
        text-field="name"
        v-bind="schema.fields.client"
        v-model="item.client"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <ocom-client-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></ocom-client-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="language"
    >
      <o-select
        :form-state="formState"
        :items="optionLanguageItems"
        :loading="optionLanguageWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="language"
        sort-field="description"
        store-name="Language"
        text-field="description"
        v-bind="schema.fields.language"
        v-model="item.language"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <language-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></language-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="language_version"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="language_version"
        v-bind="schema.fields.language_version"
        v-model="item.language_version"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="framework"
    >
      <o-select
        :form-state="formState"
        :items="optionFrameworkItems"
        :loading="optionFrameworkWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="framework"
        sort-field="description"
        store-name="Framework"
        text-field="description"
        v-bind="schema.fields.framework"
        v-model="item.framework"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <framework-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></framework-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="framework_version"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="framework_version"
        v-bind="schema.fields.framework_version"
        v-model="item.framework_version"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="front_end"
    >
      <o-select
        :form-state="formState"
        :items="optionCodeFrontEndItems"
        :loading="optionCodeFrontEndWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="front_end"
        sort-field="description"
        store-name="CodeFrontEnd"
        text-field="description"
        v-bind="schema.fields.front_end"
        v-model="item.front_end"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-front-end-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></code-front-end-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="front_end_version"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="front_end_version"
        v-bind="schema.fields.front_end_version"
        v-model="item.front_end_version"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="database"
    >
      <o-select
        :form-state="formState"
        :items="optionDatabaseItems"
        :loading="optionDatabaseWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="database"
        sort-field="description"
        store-name="Database"
        text-field="description"
        v-bind="schema.fields.database"
        v-model="item.database"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <database-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></database-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="git_url"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="git_url"
        v-bind="schema.fields.git_url"
        v-model="item.git_url"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="logins"
    >
      <project-login-form-table
        :form-state="formState"
        :label="schema.fields.logins.label"
        :level="level + 1"
        :server-errors="_se.logins"
        :validators="$v.item.logins"
        v-model="item.logins"
      >
      </project-login-form-table>
      <!-- UNCOMMENT TO USE Cards
            <project-login-form-cards v-model="item.logins"
                :validators="$v.item.logins"
                :form-state="formState"
                :label="schema.fields.logins.label"
                :level="level+1"
                :server-errors="_se.logins">
            </project-login-form-cards>
            -->
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="date_started"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        hide-time
        name="date_started"
        v-bind="schema.fields.date_started"
        v-model="item.date_started"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="date_live"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        hide-time
        name="date_live"
        v-bind="schema.fields.date_live"
        v-model="item.date_live"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="demo_site"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="demo_site"
        v-bind="schema.fields.demo_site"
        v-model="item.demo_site"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="live_site"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="live_site"
        v-bind="schema.fields.live_site"
        v-model="item.live_site"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="server_ip"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="server_ip"
        v-bind="schema.fields.server_ip"
        v-model="item.server_ip"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="support"
    >
      <o-checkbox
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="support"
        v-bind="schema.fields.support"
        v-model="item.support"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="sentry_url"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="sentry_url"
        v-bind="schema.fields.sentry_url"
        v-model="item.sentry_url"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="asana_url"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="asana_url"
        v-bind="schema.fields.asana_url"
        v-model="item.asana_url"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="active_start_date"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="active_start_date"
        v-bind="schema.fields.active_start_date"
        v-model="item.active_start_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="active_end_date"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="active_end_date"
        v-bind="schema.fields.active_end_date"
        v-model="item.active_end_date"
      ></o-date-time>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import { default as OcomClientForm } from "../../ocom_client/components/ItemForm";
import { default as LanguageForm } from "../../language/components/ItemForm";
import { default as FrameworkForm } from "../../framework/components/ItemForm";
import { default as ProjectLoginFormTable } from "../../project_login/components/ItemFormTable";
// import { default as ProjectLoginFormCards } from '../../project_login/components/ItemFormCards';
import { default as DatabaseForm } from "../../database/components/ItemForm";
import { default as CodeFrontEndForm } from "../../code_front_end/components/ItemForm";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("OcomProject"),
    CreateCodeTableFetchMixin([
      "OcomClient",
      "Language",
      "Framework",
      "Database",
      "CodeFrontEnd",
    ]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    OcomClientForm,
    LanguageForm,
    FrameworkForm,
    ProjectLoginFormTable,
    //ProjectLoginFormCards,
    DatabaseForm,
    CodeFrontEndForm,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.OcomProject, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
